import type { Middleware } from 'redux';

import { mixpanel } from '@/api/app/mixpanel';
import { RouteMap } from '@/lib/navigation/utils';

import { NavigationTypes } from '../actions/navigation';
import { AppAction } from '../actions';
import { ticketMixpanelDataSelector } from '../selectors/ticket';

const trackedRoutes = {
  'accounts/:subdomain/tickets': 'Inbox',
  'accounts/:subdomain/tickets/:ticket': 'Ticket',
};
const routeMap = new RouteMap(trackedRoutes);

export const middleware: Middleware = (api) => (next) => (action: AppAction) => {
  if (action.type === NavigationTypes.NAVIGATE) {
    action.deferredUpdate.then(({ currentPath }) => {
      const route = routeMap.findMatchingRoute(currentPath.asList);
      if (!route) return;

      const page = trackedRoutes[route];
      const routeParams = routeMap.getRouteParams(route, currentPath.asList);

      const data: Record<string, string> = {
        'Page Name': page,
        'Account Subdomain': routeParams.subdomain,
      };

      if (page === 'Ticket') {
        const { id, number } = ticketMixpanelDataSelector(routeParams.ticket, api.getState());
        Object.assign(data, {
          'Ticket Number': number,
          'Ticket ID': id,
        });
      }
      mixpanel.track('Page View', data);
    });
  }

  return next(action);
};
